import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import { LazyMarkdown } from '@sorare/core/src/atoms/markdown/LazyMarkdown';
import { ContentContainer } from '@sorare/core/src/components/landing/LandingMultiSport/ui';

const StyledContainer = styled(ContentContainer)`
  & p {
    margin-bottom: 1em;
    margin-top: 0.5em;
    line-height: 1.5em;
    color: var(--c-nd-400-opaque);
  }
  & ol li {
    list-style: decimal;
    color: var(--c-nd-400-opaque);
  }
`;

const messages = defineMessages({
  content: {
    defaultMessage: `
### What is Sorare?
Sorare is the fantasy sports game where you collect officially licensed NBA player cards, build your dream team, and compete for rewards like cash, tickets, and VIP experiences.

### What is fantasy basketball?
In Sorare fantasy basketball, you are the manager of a team of real NBA players earning points based on their live performances like points, assists, rebounds, steals, and blocks. When they shine on the field, you earn rewards!

### Why choose Sorare?
With Sorare NBA, you don't just play, you own. Collect, trade, and compete with digital cards from all 30 NBA teams in the ultimate fantasy basketball experience.
`,
  },
});

export const FAQ = () => {
  const { formatMessage } = useIntl();
  const content = formatMessage(messages.content);

  return (
    <StyledContainer>
      <LazyMarkdown data={content} />
    </StyledContainer>
  );
};
